/* istanbul ignore file */
import React from 'react';
import './ContactInfo.css';

const ContactInfo = () => (
    <section className="section contact-info">
        <div className="container">
            <div className="columns">
                <div className="column">
                    <div className="contact-item los-angeles">
                        <div className="contact-header">
                            LOS ANGELES
                        </div>
                        <div className="contact-details">
                            <p>11601 WILSHIRE BLVD</p>
                            <p>9TH FLOOR</p>
                            <p>LOS ANGELES, CA 90025</p>
                            <p className="phone"><a href="tel:(310) 445-5700">(310) 445-5700</a></p>
                        </div>
                    </div>

                    <div className="columns is-multiline other-locations">
                        <div className="column is-6-tablet is-6-desktop">
                            <div className="contact-item">
                                <div className="contact-header">
                                    SAN FRANCISCO
                                </div>
                                <div className="contact-details">
                                    <p>121 SPEAR ST</p>
                                    <p>SUITE 220</p>
                                    <p>SAN FRANCISCO, CA 94105</p>
                                    <p className="phone"><a href="tel:(415) 777-4100">(415) 777-4100</a></p>
                                </div>
                            </div>
                        </div>
                        <div className="column is-6-tablet is-6-desktop">
                            <div className="contact-item">
                                <div className="contact-header">
                                    SILICON VALLEY
                                </div>
                                <div className="contact-details">
                                    <p>333 TWIN DOLPHIN DRIVE</p>
                                    <p>SUITE 100</p>
                                    <p>REDWOOD CITY, CA 94065</p>
                                    <p className="phone"><a href="tel:(650) 200-2900">(650) 200-2900</a></p>
                                </div>
                            </div>
                        </div>
                        <div className="column is-6-tablet is-6-desktop">
                            <div className="contact-item">
                                <div className="contact-header">
                                    SEATTLE
                                </div>
                                <div className="contact-details">
                                    <p>411 FIRST AVE. SOUTH</p>
                                    <p>SUITE 300N</p>
                                    <p>SEATTLE, WA 98104</p>
                                    <p className="phone"><a href="tel:(206) 462-1895">(206) 462-1895</a></p>
                                </div>
                            </div>
                        </div>
                        <div className="column is-6-tablet is-6-desktop">
                            <div className="contact-item">
                                <div className="contact-header">
                                    VANCOUVER
                                </div>
                                <div className="contact-details">
                                    <p>3110 – 1055 DUNSMUIR STREET</p>
                                    <p>VANCOUVER</p>
                                    <p>BC V7X 1L3</p>
                                    <p className="phone"><a href="tel:(778) 328-5960">(778) 328-5960</a></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="contact-social">
                        <div className="social-title">FOLLOW US</div>
                        <div className="social-subtitle">
                            Connect with us to stay up to date
                            with the latest from
                            Hudson Pacific Properties.
                        </div>
                        <div className="social-icons">
                            <a className="social-icon facebook" target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/HudsonPPI/">
                                <div aria-label="Facebook"></div>
                            </a>
                            <a className="social-icon instagram" target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/hudsonppi/">
                                <div aria-label="Instagram"></div>
                            </a>
                            <a className="social-icon twitter" target="_blank" rel="noopener noreferrer" href="https://twitter.com/HudsonPPI">
                                <div aria-label="Twitter"></div>
                            </a>
                            <a className="social-icon linkedin" target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/company/hudson-pacific-properties-inc-?">
                                <div aria-label="LinkedIn"></div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
);

export default ContactInfo;
